import { Pagination } from 'antd';
// import enUS from 'antd/lib/locale/en_US.js';
// import { useTranslation } from 'react-i18next';

const Paginator = (props) => {
    const { total, currentPage, pageSize, onChange } = props
    // const { t } = useTranslation();
    
    // const customLocale = {
    //     ...enUS.Pagination,
    //     items_per_page: " / " + t("page"),  // Change "items / page" to "items"
    //   };

    return (
        <div className='doc-pagination'>
            <Pagination
                pageSizeOptions={[10, 20, 25, 50]}
                total={total}
                current={currentPage}
                pageSize={pageSize}
                showSizeChanger
                onChange={onChange}
                responsive
                // locale={customLocale}
                itemRender={(page, type, originalElement) => {
                    if (type === 'prev') {
                      return <button class="ant-pagination-item-link" type="button" tabindex="-1" title={"Previous Page"}><span role="img" aria-label="left" class="anticon anticon-left"><svg viewBox="64 64 896 896" focusable="false" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg></span></button>
                    //   <span role="img" aria-label="left" class="anticon anticon-left" title={t("Previous Page")}><svg viewBox="64 64 896 896" focusable="false" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg></span>
                      
                    }
                    if (type === 'next') {
                      return <button class="ant-pagination-item-link" type="button" tabindex="-1" title={"Next Page"}><span role="img" aria-label="right" class="anticon anticon-right" ><svg viewBox="64 64 896 896" focusable="false" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path></svg></span></button>
                      
                    }
                    return originalElement;
                }}
            />

        </div>
    )
};
export default Paginator;